import React from "react";

/**
 * EventomLogomark — exact SVG replica of the uploaded brand mark.
 * Three horizontal white parallelogram slashes stacked into an "E",
 * with a lime green square dot at the bottom-right of the third slash.
 */
export function EventomLogomark({ size = 40, className = "", withGlow = false, variant = "auto", ...rest }) {
  // variant: "light" (default black slashes for light bg), "dark" (white slashes for dark nav), "auto" (dark = white for backward compat)
  const slashColor = variant === "light" ? "#0A0A0A" : "#FFFFFF";
  const style = withGlow ? { filter: variant === "light" ? "none" : "drop-shadow(0 0 18px rgba(170,238,0,0.55))" } : undefined;
  return (
    <svg viewBox="0 0 260 190" width={size} height={size} className={className} style={style} {...rest}>
      <path d="M20 20 L235 20 L215 55 L0 55 Z" fill={slashColor} />
      <path d="M20 78 L200 78 L180 113 L0 113 Z" fill={slashColor} />
      <path d="M20 136 L235 136 L215 171 L0 171 Z" fill={slashColor} />
      <rect x="115" y="127" width="30" height="30" fill="#BFF907" />
    </svg>
  );
}

export default function EventomLogo({ height = 32, className = "", withGlow = false, variant = "dark" }) {
  // variant: "dark" = white slashes + white wordmark (for ink nav/footer)
  //         "light" = ink slashes + ink wordmark (for light pages)
  // Try full-lockup PNG first; if missing, compose logomark + wordmark.
  const [broken, setBroken] = React.useState(false);
  const isLight = variant === "light";
  if (!broken) {
    // The uploaded PNG has white slashes; on light bg we invert-filter it to render as ink.
    const filterCss = [
      withGlow ? "drop-shadow(0 0 18px rgba(170,238,0,0.45))" : "",
      isLight ? "invert(1) hue-rotate(180deg)" : "",
    ].filter(Boolean).join(" ") || undefined;
    return (
      <img
        src="/eventom-logo.png"
        alt="Eventom"
        height={height}
        onError={() => setBroken(true)}
        style={{ height, width: "auto", objectFit: "contain", filter: filterCss }}
        className={className}
        data-testid="eventom-logo"
      />
    );
  }
  const markSize = Math.round(height * 1.35);
  const wordColor = isLight ? "#0A0A0A" : "#FFFFFF";
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} style={{ height }} data-testid="eventom-logo">
      <EventomLogomark size={markSize} withGlow={withGlow} variant={isLight ? "light" : "dark"} />
      <span style={{
        fontFamily: "'Space Grotesk', system-ui, sans-serif",
        fontWeight: 400, fontSize: Math.round(height * 0.82), letterSpacing: "-0.01em",
        color: wordColor, lineHeight: 1, whiteSpace: "nowrap",
      }}>.eventom</span>
    </div>
  );
}
